module.exports = __webpack_public_path__ + "img/logo-web.02631d3.png";